// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__LHhVw","or":"button_select_or__2V9JI","wrapper":"button_select_wrapper__1mvtL","line":"button_select_line__3yJ-u"};